import { useCallback, useEffect, useState } from "react"
import { MobileSearchIcon } from "../../MobileSearchIcon/MobileSearchIcon"
import { SearchPane } from "../SearchPane/SearchPane"
import type { EventRouter } from "../../../../messaging/types"

export function SearchContainer({
    suggestionClicked,
    isOpen = false,
}: {
    suggestionClicked?: EventRouter<void>
    isOpen: boolean
}) {
    const [isSearchPaneOpen, setIsSearchPaneOpen] = useState(isOpen)

    const openPane = useCallback(() => {
        setIsSearchPaneOpen(true)
    }, [])

    const closePane = useCallback(() => {
        setIsSearchPaneOpen(false)
    }, [])

    useEffect(() => {
        suggestionClicked?.listen(() => {
            setIsSearchPaneOpen(false)
        })
    }, [])

    return (
        <div data-testid="mobile-search-container">
            <MobileSearchIcon onClick={openPane} />
            <SearchPane isOpen={isSearchPaneOpen} onClose={closePane} />
        </div>
    )
}
